import React from 'react';
import { Box, Typography, Button, Stack, Alert, Card } from '@mui/joy';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../../utils/FireStore';
import settings from '../../utils/settings.json';
import FenceLinkNameLogo from '../../assets/icons/name-logo/Component 1.svg';

const AccountDisabledPage = () => {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      navigate('/sign-in');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const handleContactSupport = () => {
    // You can customize this with your support email or contact form
    window.location.href = `mailto:support@${settings.companyName.toLowerCase()}.com?subject=Account Subscription Issue`;
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'background.level1',
        px: 2,
      }}
    >
      <Card
        variant="outlined"
        sx={{
          maxWidth: 500,
          width: '100%',
          p: 4,
          textAlign: 'center',
          borderRadius: 'lg',
          boxShadow: 'lg',
        }}
      >
        <Stack spacing={3} alignItems="center">
          {/* Logo */}
          <img 
            src={FenceLinkNameLogo} 
            alt={`fenceLink logo`}
            style={{ width: 160, height: 'auto' }}
          />

          {/* Main Alert */}
          <Alert 
            color="warning" 
            variant="soft" 
            size="lg"
            sx={{ width: '100%' }}
          >
            <Stack spacing={1} alignItems="center">
              <Typography level="title-lg" sx={{ fontWeight: 'bold' }}>
                Account Subscription Required
              </Typography>
              <Typography level="body-md">
                This company's subscription to FenceLink is no longer active.
              </Typography>
            </Stack>
          </Alert>

          {/* Description */}
          <Stack spacing={2} sx={{ textAlign: 'center' }}>
            <Typography level="body-lg">
              To continue using {settings.companyName}, please contact the company
            </Typography>

            {/* <Box sx={{ textAlign: 'left', px: 2 }}>
              <Typography level="body-md" sx={{ mb: 1 }}>
                • Renew your subscription
              </Typography>
              <Typography level="body-md" sx={{ mb: 1 }}>
                • Update payment information
              </Typography>
              <Typography level="body-md">
                • Contact our support team for assistance
              </Typography>
            </Box> */}

            <Typography level="body-sm" sx={{ color: 'text.tertiary', fontStyle: 'italic' }}>
              If you believe this is an error, please contact support.
            </Typography>
          </Stack>

          {/* Action Buttons */}
          {/* <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ width: '100%', mt: 3 }}>
            <Button
              variant="outlined"
              color="neutral"
              fullWidth
              onClick={handleContactSupport}
            >
              Contact Support
            </Button>
            <Button
              variant="solid"
              color="primary"
              fullWidth
              onClick={handleSignOut}
            >
              Sign Out
            </Button>
          </Stack> */}

          {/* Footer */}
          <Typography level="body-xs" sx={{ color: 'text.tertiary', mt: 2 }}>
            © {settings.companyName} {new Date().getFullYear()}
          </Typography>
        </Stack>
      </Card>
    </Box>
  );
};

export default AccountDisabledPage;